import { combineReducers } from 'redux';
import recentJournals from './recentJournals';

export default combineReducers({
  recentJournals,
});
